import { flattenArray } from '../../../utils/array-utils';
import { afterOrEqualToDate } from '../../../utils/date/after-or-equal-to-date';
import { getStartOfWeek } from '../../../utils/date/get-start-of-week';
import { getJourneyById } from '../../journey/selectors/get-journey-by-id';
import { getNextShowtimeForJourney } from '../../journey/utils/journey-utils';
import { JourneyGroupType } from '../types/journey-group';
import { groupJourneysByMonthAndYear } from './group-journeys-by-month-and-year';
import { comparePastJourneyGroups } from './sort-journey-groups';
export const groupPastJourneys = (journeys, startWeekOnSunday, currentGroups) => {
    var _a, _b;
    const groups = [];
    const lastWeekJourneyIds = ((_a = currentGroups === null || currentGroups === void 0 ? void 0 : currentGroups.find(group => group.type === JourneyGroupType.LastWeek)) === null || _a === void 0 ? void 0 : _a.journeyIds) || [];
    // Grabs the current journey ids from the monthly groups
    const currentMonthlyJourneyIds = (_b = currentGroups === null || currentGroups === void 0 ? void 0 : currentGroups.filter(group => group.type === JourneyGroupType.Monthly)) === null || _b === void 0 ? void 0 : _b.map(group => group.journeyIds).reduce(flattenArray, []);
    // Gets the journeys currently in the monthly journey groups, else create an empty array.
    const monthlyJourneys = currentMonthlyJourneyIds
        ? currentMonthlyJourneyIds.reduce((acc, nextJourneyId) => {
            const journey = getJourneyById(nextJourneyId);
            if (!!journey)
                acc.push(journey);
            return acc;
        }, [])
        : [];
    const startOfWeek = getStartOfWeek(startWeekOnSunday);
    journeys.forEach((journey) => {
        const showtime = getNextShowtimeForJourney(journey);
        if (!showtime)
            return;
        if (afterOrEqualToDate(showtime.schedule.startsAt, startOfWeek)) {
            lastWeekJourneyIds.push(journey.id);
        }
        else {
            monthlyJourneys.push(journey);
        }
    });
    groups.push(...groupJourneysByMonthAndYear(monthlyJourneys));
    if (lastWeekJourneyIds.length) {
        groups.push({
            id: 'LastWeek',
            type: JourneyGroupType.LastWeek,
            journeyIds: lastWeekJourneyIds
        });
    }
    return groups.sort(comparePastJourneyGroups);
};
